import React, { useEffect, useState } from "react"
import { Box, Grid } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import Card from "components/Card/Card"
import AppSelect from "components/StyledComponents/AppSelect"
import AppTextField from "components/StyledComponents/AppTextField"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { postVIPEmailMappingAction } from "redux/DMV/actions"
import { toast } from "react-toastify"

const RestaurantEmailConfig = () => {
  const dispatch = useDispatch()
  const [restaurant1, setRestaurant1] = useState("")
  const [restaurant2, setRestaurant2] = useState("")
  const [subject, setSubject] = useState("")
  const [breadCrumbs, setBreadCrumbs] = useState()

  const { restaurantList } = useSelector((state) => state.user)

  const restaurantOptions =
    restaurantList?.map((item) => ({
      label: item.name,
      value: item.id
    })) || []

  useEffect(() => {
    document.title = "Restaurant Email Configuration"
    setBreadCrumbs(createBreadcrumbs())
  }, [])

  const handleSubmit = () => {
    if (!restaurant1) {
      toast.error("Restaurant 1 is required", { position: "bottom-left" })
      return
    }

    if (!subject) {
      toast.error("Email Subject is required", { position: "bottom-left" })
      return
    }

    const payload = {
      subject: subject,
      restaurant_one: restaurant1,
      restaurant_two: restaurant2 || null
    }

    dispatch(postVIPEmailMappingAction(payload))
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Header title="Restaurant Email Configuration" breadCrumbs={breadCrumbs} />
      </Grid>
      <Grid item xs={12}>
        <Card style={{ paddingBottom: 24 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: "600px" }}>
            <AppSelect
              label="Select Restaurant 1"
              value={restaurant1}
              onChange={(e) => {
                setRestaurant1(e.target.value)
                if (e.target.value === restaurant2) {
                  setRestaurant2("")
                }
              }}
              menuItems={restaurantOptions}
              isRequired={true}
            />
            <AppSelect
              label="Select Restaurant 2"
              value={restaurant2}
              onChange={(e) => setRestaurant2(e.target.value)}
              menuItems={restaurantOptions.filter((opt) => opt.value !== restaurant1)}
            />
            <AppTextField
              label="Email Subject"
              placeholder="Enter email subject"
              value={subject}
              isUpperCase={true}
              fullWidth
              onChange={(e) => setSubject(e.target.value)}
            />
            <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
              <AppButton onClick={handleSubmit}>Submit</AppButton>
            </Box>
          </Box>
        </Card>
      </Grid>
    </Grid>
  )
}

export default RestaurantEmailConfig
